/**
 * Client Constants
 */

export const CLIENT = {
  SCREEN_WIDTH: 80,
  SCREEN_HEIGHT: 30,
  DEFAULT_FG_COLOR: 7,
  DEFAULT_BG_COLOR: 0,
  DEFAULT_WS_PORT: 10051,
  HTTP_STANDARD_PORT: '80',
  HTTPS_STANDARD_PORT: '443',
} as const;

export const ADPCM = {
  SAMPLE_RATE: 11025,
  BUFFER_SIZE: 3,
  VOLUME: 0.7,
} as const;

export const CRT_DECAY = {
  LEVEL_3_THRESHOLD: 70,
  LEVEL_2_THRESHOLD: 40,
  LEVEL_1_THRESHOLD: 20,
} as const;

export const RECONNECT = {
  MAX_ATTEMPTS: 10,
  BASE_DELAY_MS: 1000,
  BACKOFF_EXPONENT: 2,
  MAX_DELAY_MS: 30000,
  PING_INTERVAL_MS: 30000,
} as const;
